import config from '../config';
import { getCookie } from './cookies';
import { authHeader, handleResponse } from './helper';

const getConsultations = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getUnfishedExams = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/getUnfinishedExams`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getMedicalConsultationDetails = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/${params.id}`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const reevaluationDocuments = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/revaluation/getDocuments/${params.id}`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const getPatientData = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      "branch_office_id": getCookie('branch_office_id'),
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/patients/${null}/getData`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getPatientIdCard = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiGeneralUrl}/patients/carnetPhoto/${params.id}`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

const getServicesList = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/getServices/${params.id}`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const signServices = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/sign`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const presignServices = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/presign`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const cancelPresignServices = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/cancelPresign`);
  return await fetch(url, requestOptions).then(handleResponse);
}

const createMedicalConsultationReport = async (params) => {
  const countryCode = getCookie('country_code');
  let body = {};

  if (countryCode === 'PE' && params.department === 'health') {
    body = {
      'id': params.id,
      'type': 'medical',
      'countryCode': 'pe',
      'output': 'pdf',
      'role': params.role,
      'saveReport': params.saveReport,
      ...(params.signer_admin_id && { signer_admin_id: params.signer_admin_id }),
    };
  } else if (countryCode === 'PE' && params.department === 'psychological') {
    body = {
      'id': params.id,
      'type': 'medical',
      'countryCode': 'pe',
      'output': 'pdf',
      'saveReport': params.saveReport,
      ...(params.signer_admin_id && { signer_admin_id: params.signer_admin_id }),
    };
  }

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': countryCode === 'CL' ? 'Bearer ' + getCookie('user') : getCookie('user'),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(countryCode === 'CL' ? params : body),
  };

  const urlString = countryCode === 'CL'
    ? `${config.apiClinicalUrl}/medicalConsultation/createMedicalConsultationReport`
    : `${config.apiReportUrl}/generate`;

  const url = new URL(urlString);

  if (countryCode === 'PE') {
    const response = await fetch(url, requestOptions);
    const pdf = await response.text();
    return { pdf };
  }
  return await fetch(url, requestOptions).then(handleResponse);
};

const calledByDoctor = async (params) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/calledByDoctor`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const getExamList = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/exams/getExamList`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getPendingReasons = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/consultationStateReasons`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getIndications = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/indications`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getSuggestions = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/suggestions`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const saveConsultation = async (params) => {
  const requestOptions = {
    method: params.id ? 'PUT' : 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const action = params.id ? 'update' : 'create';
  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/${action}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const sendPatientDocument = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(
    `${config.apiClinicalUrl}/revaluation/uploadReevaluationFiles`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const deletePatientDocument = async (params) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(
    `${config.apiClinicalUrl}/revaluation/removeReevaluationFile`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const getServicesPerformed = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/getHistoricalPrestations`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getLastMeasurements = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/lastPatientMeasurements`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getPrescriptions = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/prescriptionItems`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const generatePrescription = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalPrescriptions/createMedicalPrescriptionReport`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const signMedicalPrescription = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalPrescriptions/signPrescriptions`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const getGeneratedPrescriptions = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };
  const url = new URL(`${config.apiClinicalUrl}/medicalPrescriptions`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getMedicalPrescription = async (prescriptionId) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };
  const url = new URL(`${config.apiClinicalUrl}/medicalPrescriptions/${prescriptionId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const deletePrescription = async (prescriptionId) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };
  const url = new URL(`${config.apiClinicalUrl}/medicalPrescriptions/${prescriptionId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getReports = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      branch_office_id: getCookie('branch_office_id'),
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/getReports`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key] && params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const listReportsChanges = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/listReportsChanges`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key] && params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const applyReportchanges = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      branch_office_id: getCookie('branch_office_id'),
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/applyReportchanges`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const notifyReevaluation = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      branch_office_id: getCookie('branch_office_id'),
      ...authHeader(),
    },
  };
  const url = new URL(`${config.apiClinicalUrl}/revaluation/notify`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const enableReport = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/enableReport`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

export const validateExams = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/validateExams`
  );
  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }
  return await fetch(url, requestOptions).then(handleResponse);
}

export const saveReports = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/saveReports`
  );
  return await fetch(url, requestOptions).then(handleResponse);
}

export const expirationDate = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const urlString = `${config.apiClinicalUrl}/medicalConsultation/expirationDate`;

  const url = new URL(urlString);

  return await fetch(url, requestOptions).then(handleResponse);
};

const getAvailableAnamneses = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiClinicalUrl}/medicalConsultation/getAvailableAnamneses`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key] && params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};


const getDiagnosticsForConsultation = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/getDiagnosticsForConsultation`);

  if (params) {
    Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const saveDiagnostics = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/saveDiagnostics`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const saveEntityDiagnostics = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/saveEntityDiagnostics`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getDiagnosticTypificationOptions = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/diagnosticTypificationOptions`);

  return await fetch(url, requestOptions).then(handleResponse);
};

const getBatteryValidity = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/batteryValidity/${params.id}`);

  if (params.admissionPatientId) {
    url.searchParams.append('admissionPatientId', params.admissionPatientId);
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const consultationService = {
  getConsultations,
  getPatientData,
  getPatientIdCard,
  getServicesList,
  signServices,
  getExamList,
  getPendingReasons,
  getIndications,
  getSuggestions,
  saveConsultation,
  getServicesPerformed,
  getLastMeasurements,
  getPrescriptions,
  generatePrescription,
  getGeneratedPrescriptions,
  getMedicalPrescription,
  deletePrescription,
  getMedicalConsultationDetails,
  getReports,
  enableReport,
  getUnfishedExams,
  signMedicalPrescription,
  createMedicalConsultationReport,
  calledByDoctor,
  reevaluationDocuments,
  sendPatientDocument,
  deletePatientDocument,
  notifyReevaluation,
  presignServices,
  cancelPresignServices,
  getAvailableAnamneses,
  listReportsChanges,
  applyReportchanges,
  getDiagnosticsForConsultation,
  saveDiagnostics,
  saveEntityDiagnostics,
  getDiagnosticTypificationOptions,
  getBatteryValidity,
};